import { ActionReducer, combineReducers } from "@ngrx/store";
import { dashboardReducer } from "@app/store/dashboard/reducers/dashboard.reducer";
import { AppState } from "@app/store/app.state";

export const appReducer: ActionReducer<AppState> = combineReducers({
    dashboard: dashboardReducer,
    //     add new reducers
});
